import { AbstractDomComponent } from './AbstractDomComponent';

// Refers to the existed blocks

export class BlockComponent extends AbstractDomComponent {
    #element;

    constructor(elem) {
        super();

        this.#element = elem;
    }

    _prepareToShow() {
        if (!this.#element) return;

        this.#element.style.display = null;
    }

    _show() {
        if (!this.#element) return;

        this.#element.classList.add('activating');
        this.#element.classList.add('active');

        this._timeout = setTimeout(() => {
            this.#element.classList.remove('activating');
        }, 1200);
    }

    _hide() {
        if (!this.#element) return;

        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this.#element.classList.remove('active');
        this.#element.classList.remove('activating');
    }

    _hidden() {
        if (!this.#element) return;

        this.#element.style.display = 'none';
    }

    _clear() {
        this.#element = null;
    }

    get element() {
        return this.#element;
    }

    get parentNode() {
        return this.#element.parentNode;
    }

    get _elementsList() {
        return [this.#element];
    }
}
